import { observer } from 'mobx-react-lite'

import { RowContent } from 'components/ModalsContainer/v1Modals/PatientSummary/common'
import { getHeight, getWeight } from 'util/apiFieldFormatters'
import { formatDate } from 'util/formatters'

import PendingVisit from 'models/Provider/visits/PendingVisit'

const formatAddr = (addresses, fallBack) => {
  if (!addresses?.length) {
    return fallBack
  }

  const { city, state, street1, zip } = addresses.find((a) => a.preferred) || addresses[0]

  return `${street1}, ${city}, ${state} ${zip}`
}

type PatientProps = {
  visit: PendingVisit
}

const Patient = ({ visit }: PatientProps) => {
  if (!visit || !visit.memberExtendedData) {
    return null
  }

  const { member, medicalHistory } = visit.memberExtendedData.privateData

  const patientRows = [
    {
      label: 'name',
      content: `${member.firstName} ${member.lastName}`,
    },
    {
      label: 'address',
      content: formatAddr(
        member.addresses,
        // TODO - improve type of Pending visit model
        // @ts-ignore
        visit.location,
      ),
    },
    {
      label: 'height',
      content: getHeight(medicalHistory.heightFt, medicalHistory.heightIn),
    },
    {
      label: 'weight',
      content: getWeight(medicalHistory.weightLbs),
    },
    {
      label: 'phone',
      content: member.phones?.[0]?.number,
    },
    {
      label: 'sex',
      content: member.gender,
    },
    {
      label: 'birth date',
      content: formatDate(member.dob),
    },
  ]
  const isAnyPatientDataProvided = patientRows.some((row) => row.content)

  if (!isAnyPatientDataProvided) return null
  return (
    <div className="mb-5">
      <h6 className="typography-body-xl text-primary-800 font-medium mb-4">Patient</h6>
      {patientRows.map(
        ({ label, content }) => content && <RowContent label={label} content={content} className="mb-6" key={label} />,
      )}
    </div>
  )
}

export default observer(Patient)
